var React = require('react');

function NewsInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:currentColor;}.cls-2{fill:none;}")),React.createElement("path",{"className":"cls-1","d":"M28.38,26.61H7.48V9.25h20.9ZM8.9,25.2H27V10.67H8.9Z","key":1}),React.createElement("rect",{"className":"cls-1","x":"11.49","y":"19.75","width":"12.73","height":"0.6","key":2}),React.createElement("rect",{"className":"cls-1","x":"11.49","y":"13.35","width":"5.81","height":"4.28","key":3}),React.createElement("rect",{"className":"cls-1","x":"11.49","y":"22.14","width":"12.73","height":"0.6","key":4}),React.createElement("rect",{"className":"cls-2","width":"35.86","height":"35.86","key":5})]);
}

NewsInline.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 35.86 35.86"};

module.exports = NewsInline;

NewsInline.default = NewsInline;
